module.exports = __webpack_public_path__ + "img/copy 3@2x.459d0357.png";